<rid-categorise
  class="h-dvh"
  name="Sorteren | Woord & Regelsymbool"
  [questions]="[
    {
      id: '3',
      assignment: 'Sleep het woord op het juiste regelsymbool',
      item: { type: 'WORD', word: 'is' },
      options: [
        { type: 'RULE', rule: '+' },
        { type: 'RULE', rule: '-' },
        { type: 'RULE', rule: '=' },
      ],
      answer: 2,
    },
    {
      id: '4',
      assignment: 'Sleep het woord op het juiste regelsymbool',
      item: { type: 'WORD', word: 'plus' },
      options: [
        { type: 'RULE', rule: '+' },
        { type: 'RULE', rule: '-' },
        { type: 'RULE', rule: '=' },
      ],
      answer: 0,
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/categorise'])"
/>
